import React from 'react';
import Link from 'next/link';
import Icons from '../../../public/icons/othersIcon'; // Using exsiting icons if possible, or simple svg

const AiCTA = ({
    title = "Make Hiring Faster, Safer & Smarter",
    description = "Stop relying on slow and manual background checks. Switch to AI-powered verification today.",
    btn1Text = "Book a Demo",
    btn2Text = "Speak to Our Expert"
}) => {
    return (
        <section className="bg-white py-20 relative overflow-hidden">
            {/* Decorative grid pattern or overlay could go here */}
            <div className="container-padding-x mx-auto px-4 max-w-6xl text-center relative z-10">
                <h2 className="text-3xl md:text-5xl font-bold text-[#3A3D46] mb-6">
                    {title}
                </h2>
                <p className="text-[#3A3D46] text-lg md:text-xl mb-10 max-w-2xl mx-auto">
                    {description}
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link href="/contact" className="bg-[#168DEF] text-white hover:bg-[#1375c7] px-8 py-4 rounded-lg font-bold transition-all shadow-lg flex items-center gap-2 group">
                        {btn1Text}
                        <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                    </Link>

                    <Link href="/contact" className="bg-white border border-[#168DEF] text-[#168DEF] hover:bg-gray-50 px-8 py-4 rounded-lg font-bold transition-all flex items-center gap-2">
                        {/* Placeholder for phone icon or similar */}
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        {btn2Text}
                    </Link>
                </div>
            </div>

            {/* Background elements */}
            <div className="absolute top-0 left-0 w-full h-full opacity-30 pointer-events-none">
                <div className="absolute inset-0 bg-[url('/images/grid-pattern.svg')] opacity-10"></div>
            </div>
        </section>
    );
};

export default AiCTA;
